export default { sha: '428adace7655802864d7c71b31a1e7323ea99df9', buildNumber: 'undefined' }
